export default "__VITE_ASSET__f32451da__"